import { FunctionComponent, useEffect } from 'react';
import { useDispatch } from '@cbridge-utils/react-redux';
import { NodeAction } from '../../node.action';
import { INodeListParams } from '../../node.interface';

export const NodeListSubscriber: FunctionComponent<INodeListParams> = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(NodeAction.loadList.started(props));
  }, [dispatch, props]);

  useEffect(() => {
    return () => {
      dispatch(NodeAction.destroy());
    };
  }, [dispatch]);

  return null;
};
